"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "agerola": {
    "046d80b8": [{
      "hkey": "2ea512d6",
      "slug": "agerola",
      "name": "Agerola",
      "primary": true,
      "skipSearch": false
    }],
    "bomerano": [{
      "hkey": "2ea512d6",
      "slug": "agerola",
      "name": "Agerola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4d8e3c3b": [{
      "hkey": "2ea512d6",
      "slug": "agerola",
      "name": "Agerola",
      "primary": true,
      "skipSearch": false
    }],
    "campora": [{
      "hkey": "2ea512d6",
      "slug": "agerola",
      "name": "Agerola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b98294cf": [{
      "hkey": "2ea512d6",
      "slug": "agerola",
      "name": "Agerola",
      "primary": true,
      "skipSearch": false
    }],
    "pianillo": [{
      "hkey": "2ea512d6",
      "slug": "agerola",
      "name": "Agerola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "50944840": [{
      "hkey": "2ea512d6",
      "slug": "agerola",
      "name": "Agerola",
      "primary": true,
      "skipSearch": false
    }],
    "ponte": [{
      "hkey": "2ea512d6",
      "slug": "agerola",
      "name": "Agerola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ae95e503": [{
      "hkey": "2ea512d6",
      "slug": "agerola",
      "name": "Agerola",
      "primary": true,
      "skipSearch": false
    }],
    "san-lazzaro": [{
      "hkey": "2ea512d6",
      "slug": "agerola",
      "name": "Agerola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d1f2c4d4": [{
      "hkey": "2ea512d6",
      "slug": "agerola",
      "name": "Agerola",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria": [{
      "hkey": "2ea512d6",
      "slug": "agerola",
      "name": "Agerola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;